import { render, staticRenderFns } from "./addGame.vue?vue&type=template&id=53413556"
import script from "./addGame.vue?vue&type=script&lang=js"
export * from "./addGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports